import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { useEffect, useState } from "react";

import Login from "./pages/Login";
import Pos from "./pages/Pos";
import SalesDetail from "./pages/SalesDetail";
import Clients from "./pages/Clients";
import Products from "./pages/Products";
import Suppliers from "./pages/Suppliers";
import Purchase from "./pages/Purchase";
import InvoiceList from "./pages/invoices/InvoiceList";
import CreditNotes from "./pages/CreditNotes";
import DebitNotes from "./pages/DebitNotes";
import Reports from './pages/reports/Reports';
import InventoryAdjustments from "./pages/InventoryAdjustments";
import InventoryLoad from "./pages/InventoryLoad"; 
import ContingenciaEventos from "./pages/ContingenciaEventos";

import CashRegister from './components/cash/CashRegister';
import CashSessionHistory from "./components/cash/CashSessionHistory";
import CashSessionDetail from "./components/cash/CashSessionDetail";

import Sidebar from "./components/Sidebar";
import TopBar from "./components/TopBar";
import PrivateRoute from "./components/PrivateRoute";

// Ruta que solo el encargado puede ver
function EncargadoRoute({ children }) {
  const { isEncargado } = useAuth();
  if (!isEncargado) {
    return <Navigate to="/pos" replace />;
  }
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const handleWheel = (e) => {
      if (document.activeElement?.type === 'number') {
        document.activeElement.blur();
      }
    };
    document.addEventListener('wheel', handleWheel, { passive: true });
    return () => document.removeEventListener('wheel', handleWheel);
  }, []);

  useEffect(() => {
    setSidebarOpen(false);
  }, [window.location.pathname]);

  useEffect(() => {
    const sidebarEl = document.querySelector('.sidebar');
    const overlayEl = document.querySelector('.sidebar-overlay');
    if (sidebarEl) {
      sidebarEl.classList.toggle('sidebar-open', sidebarOpen);
    }
    if (overlayEl) {
      overlayEl.classList.toggle('show', sidebarOpen);
    }
    if (window.innerWidth <= 768) {
      document.body.style.overflow = sidebarOpen ? 'hidden' : '';
    }
  }, [sidebarOpen]);

  const toggleSidebar = () => setSidebarOpen(prev => !prev);
  const closeSidebar = () => setSidebarOpen(false);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/"
        element={user ? <Navigate to="/pos" replace /> : <Navigate to="/login" replace />}
      />

      <Route
        path="/login"
        element={user ? <Navigate to="/pos" replace /> : <Login />}
      />

      <Route
        path="/*"
        element={
          <PrivateRoute>
            <div className="d-flex">
              <div className="sidebar-overlay" onClick={closeSidebar}></div>
              <Sidebar onClose={closeSidebar} />
              <div className="main-content">
                <TopBar onMenuToggle={toggleSidebar} />
                <div className="content-wrapper">
                  <Routes>
                    {/* Acceso para todos */}
                    <Route path="/pos" element={<Pos />} />
                    <Route path="/sales/:id" element={<SalesDetail />} />
                    <Route path="/invoices" element={<InvoiceList />} />
                    <Route path="/cash" element={<CashRegister />} />
                    <Route path="/cash/history" element={<CashSessionHistory />} />
                    <Route path="/cash/session/:id" element={<CashSessionDetail />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/inventory-adjustments" element={<InventoryAdjustments />} />
                    <Route path="/inventory-load" element={<InventoryLoad />} /> 
                    <Route path="/clients" element={<Clients />} />
                    <Route path="/contingencia" element={<ContingenciaEventos />} />

                    {/* Solo encargado */}
                    <Route path="/purchase" element={<EncargadoRoute><Purchase /></EncargadoRoute>} />
                    <Route path="/suppliers" element={<EncargadoRoute><Suppliers /></EncargadoRoute>} />
                    <Route path="/reports" element={<EncargadoRoute><Reports /></EncargadoRoute>} />
                    <Route path="/credit-notes" element={<EncargadoRoute><CreditNotes /></EncargadoRoute>} />
                    <Route path="/debit-notes" element={<DebitNotes />} />
                    <Route path="*" element={<h4>Página no encontrada</h4>} />
                  </Routes>
                </div>
              </div>
            </div>
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;